import React from "react";

import Link from "core/Link";
import { LinkContainer } from "../styles";

import InfiniteScrolling from "../infinite-scrolling";
import FetchInactiveUploads from "./fetch-inactive-uploads";
import InactiveUpload from "./inactive-upload";

const InfiniteDeniedUploads = ({ uploads, loadMoreUploads }) => {
    const linkProps = {
        size: "md",
        styleType: "primary"
    };

    return (
        <section
            id="flagged"
            className="infinite-page user-icons container row"
        >
            <header className="display-flex col-xs-12">
                <h3 className="ui_close">Denied uploads</h3>
                <LinkContainer>
                    <Link
                        target="_blank"
                        href="https://thenounproject.zendesk.com/hc/en-us/articles/360010200014"
                        {...linkProps}
                    >
                        Learn how to fix denied icons
                    </Link>
                    <Link href="/dashboard" {...linkProps}>
                        Dashboard
                    </Link>
                </LinkContainer>
            </header>
            <ul id="flagged-uploads" className="col-xs-12 dashboard-user">
                {uploads.length ? (
                    <InfiniteScrolling
                        loadMore={loadMoreUploads}
                        elements={
                            uploads &&
                            uploads.map(upload => (
                                <InactiveUpload
                                    key={upload.id}
                                    upload={upload}
                                />
                            ))
                        }
                    />
                ) : (
                    <h2>There aren't any uploads to show</h2>
                )}
            </ul>
        </section>
    );
};

export default function InfiniteDeniedUploadsWrapper() {
    return (
        <FetchInactiveUploads limit={20} offset={0} uploadState="denied">
            <InfiniteDeniedUploads />
        </FetchInactiveUploads>
    );
}
